const set = (key, value) => {
  window.localStorage.setItem(key, value)
}

const get = (attr) => window.localStorage.getItem(attr)

const clear = () => {
  window.localStorage.clear()
}

export default { set, get, clear }
